<template>
  <div class="wechat-auth">
    <img src="~assets/img/logo.png" class="logo" />
    <mu-button color="primary" class="button" @click="submit"
      >确认登录</mu-button
    >
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  data() {
    return {}
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    submit() {
      const code = this.getQueryString('code')
      const socketId = this.getQueryString('state')
      backend(api.wechat.qrcodeLogin, { code, socketId }).then((result) => {
        if (result.statusCode === 200) {
          this.$toast.success('登录成功')
        }
      })
    }
  },
  mounted() {
    this.wsInit()
  }
}
</script>

<style lang="less" scoped>
.wechat-auth {
  display: flex;
  justify-content: center;
  flex-direction: column;
  .logo {
    width: 60%;
    margin: 20% auto;
    display: block;
  }
  .button {
    width: 60%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/wechat/login.vue